import { HttpClient } from '@angular/common/http';
import { Component, Injector } from '@angular/core';
import { Color } from 'src/app/config/color';
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';
import { httpOptions } from 'src/app/submodules/angular-common/http-util';
import { buildUrl } from 'submodules/engine-common/util';
import { FileDto } from '../../../base-types';
import { FormSettings } from '../../../forms/form-settings';
import { PageFormComponent } from '../../../forms/page-form.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends PageFormComponent {

  public username: string;
  public bgColor = Color.auxiliary;
  
  constructor(
    protected _injector: Injector
  ) { 
    super(_injector);
  }

  async ngOnInit() {
    await super.init()
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        currentPassword: { required: true, allowBlanks: false },
        newPassword: { required: true, allowBlanks: false },
        newPasswordConfirmation: { required: true, allowBlanks: false }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[] }> {
    return {}
  }
  
  /** @override */
  protected async _submitHook() {
    console.log('this.currentValues :>> ', this.currentValues);
    await this._injector.get(HttpClient).put(
                            buildUrl(
                              this._injector.get(EnvironmentDataService).environment.getValue("endpoints.authApi"),
                              ["secure","v1","change-password"]),
                            {
                              'current-password': this.currentValues.currentPassword as string,
                              'new-password': this.currentValues.newPassword as string,
                              'new-password-confirmation': this.currentValues.newPasswordConfirmation as string
                            },
                            httpOptions()
                          ).toPromise()
  }
}
